// NPM
import React, { useState, useEffect } from "react";
import _ from "lodash";

// State
import { useDispatch } from "react-redux";
import { setCampaignConfig } from "features/campaignConfig/campaignConfigSlice";
import { setParties } from "features/parties/partiesSlice";
import { setResponsiveView } from "features/responsive/responsiveSlice";
import { setRegion } from "features/region/regionSlice";

// Services
import apiService from "services/apiService";

// Styles
import "styles/index.scss";

// Components
import Theme from "components/Theme";
import TopCredits from "components/TopCredits";
import LastUpdated from "components/LastUpdated";
import ElectionOutcome from "components/ElectionOutcome";
import ShareSection from "components/Social/ShareSection";
import VoteShare from "components/VoteShare";
import SeatShare from "components/SeatShare";
import SeatDistribution from "components/SeatDistribution";
import TimeSeries from "components/TimeSeries";
import RidingProjections from "components/RidingProjections";
import Changelog from "components/Changelog";
import Credits from "components/Credits";
import GlobalRegionSelector from "./components/RegionSelector/GlobalRegionSelector";
import Stack from "./components/shared/Stack";
import { useEmbed } from "./hooks/useEmbed";

function App() {
  const [validCampaign, setValidCampaign] = useState(true);
  const isEmbedded = useEmbed();

  const dispatch = useDispatch();
  dispatch(setResponsiveView(window.innerWidth));

  // Handle window resizing
  useEffect(() => {
    function handleResize() {
      dispatch(setResponsiveView(window.innerWidth));
    }
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => loadData(), []);

  const loadData = async () => {
    const campaignConfigResponse = await fetch(
      apiService.apiURL("campaign_config"),
    );
    if (campaignConfigResponse.status === 404) {
      setValidCampaign(false);
    } else {
      const campaignConfigJson = await campaignConfigResponse.json();
      dispatch(setCampaignConfig(campaignConfigJson));
      const defaultRegion = campaignConfigJson.regions.find((r) => r.default);
      dispatch(setRegion(defaultRegion.name));

      const partiesResponse = await fetch(apiService.apiURL("parties"));
      const partiesJson = await partiesResponse.json();
      dispatch(setParties(partiesJson));
    }
  };

  if (isEmbedded) {
    return (
      <React.Fragment>
        <Stack className="App container">
          <Theme />
          <VoteShare />
        </Stack>
      </React.Fragment>
    );
  }

  if (validCampaign) {
    return (
      <React.Fragment>
        <Stack className="App container">
          <Theme />
          {/*<Header />*/}
          <Stack gap={50}>
            <Stack gap={24}>
              <Stack gap={10}>
                <TopCredits />
                <LastUpdated />
              </Stack>
              <ElectionOutcome />
            </Stack>
            <Stack gap={36}>
              <GlobalRegionSelector />
              <VoteShare />
              <ShareSection />
            </Stack>
          </Stack>
          <SeatShare />
          <SeatDistribution />
          <TimeSeries />
          <RidingProjections />
          <Changelog />
          <Credits />
        </Stack>

        {/*<Footer />*/}
      </React.Fragment>
    );
  } else {
    return (
      <div className="App container is-fluid">
        <div className="Header">
          <h1 className="Header__title">The Signal</h1>
          <p className="Header__description">Invalid Campaign</p>
        </div>
      </div>
    );
  }
}

export default App;
